var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"id":"logs"}},[_c('v-col',{attrs:{"sm":"12"}},[_c('h2',[_vm._v("Administration Logs")])]),_c('v-col',{attrs:{"sm":"12","md":"3"}},[_c('search-parameters')],1),_c('v-col',{attrs:{"sm":"12","md":"9"}},[_c('log-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }